import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { Observable } from 'rxjs';
import { LinkEvidenciaService } from '../services/link-evidencia.service';

@Injectable({
  providedIn: 'root',
})
export class LinkEvidenciaResolver implements Resolve<boolean> {
  constructor(private service: LinkEvidenciaService) { }

  resolve(route: ActivatedRouteSnapshot): Observable<any> {
    return this.service.getById(route.params.id);
  }
}
